import find from 'lodash/find'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { actions } from '@/reducers/relatedAssets'
import { translate } from '@/utils/translations'

import Options from './Options'
import SingleVariantOption from './SingleVariantOption'

const VariantSelector = ({ assetId, selectedVariant, variantOptions }) => {
  const { duration, id } = selectedVariant
  const isEditingAllowed = Object.keys(variantOptions).length > 1
  const dispatch = useDispatch()

  const handleOnChange = value => {
    const variant = find(variantOptions, { 'id': parseInt(value) })

    dispatch(actions.updateAssetSelectedVariant({ assetId, variant }))
  }

  return (
    <Choose>
      <When condition={isEditingAllowed}>
        <div className='u-push-half--top d-inline-block mr-3'>
          <label
            className='d-block cart-item-duration u-weight--medium'
            htmlFor={`variant-select-${assetId}`}
          >
            {translate('common.duration')}
          </label>
          <select
            defaultValue={id.toString()}
            id={`variant-select-${assetId}`}
            onChange={e => handleOnChange(e.target.value)}
          >
            <Options {...{ variantOptions }} />
          </select>
        </div>
      </When>
      <Otherwise>
        <SingleVariantOption duration={duration} />
      </Otherwise>
    </Choose>
  )
}

export default VariantSelector

VariantSelector.propTypes = {
  assetId: PropTypes.number.isRequired,
  selectedVariant: PropTypes.object.isRequired,
  variantOptions: PropTypes.object.isRequired
}
